export const NewPropertyFields = {
  address1: "",
  address2: "",
  amenities: "",
  askingRent: "",
  askingPrice: "",
  bamMapData: "",
  buildingClass: "",
  capacity: "",
  centerType: "",
  city: "",
  clearHeight: "",
  columnSpacing: "",
  comments: "",
  crossStreets: "",
  customFields: [],
  dockHighDoors: "",
  floors: "",
  isHidden: false,
  isClientShortlist: false,
  latitude: "",
  longitude: "",
  lotSize: "",
  market: "",
  name: "",
  officeSpace: "",
  // @ts-ignore
  order: 0,
  owner: "",
  parkingRatio: "",
  parkingSpaces: "",
  parkingSpacesCars: "",
  parkingSpacesTrailers: "",
  postalCode: "",
  powerAmps: "",
  powerVolts: "",
  propertySize: "",
  sprinklers: "",
  stateProvince: "",
  submarket: "",
  stopDetails: "",
  // @ts-ignore
  surveyId: "",
  totalAvailableSpace: "",
  virtualTour: "",
  yearBuilt: "",
  yearRenovated: "",
  zoning: "",
};

// Mapping aliases used to resolve table-config ids to property keys/labels.
export const FIELD_KEY_ALIASES: Record<string, string> = {
  property: "name",
  addressline1: "address1",
  addressline2: "address2",
  state: "stateprovince",
  zipcode: "postalcode",
  availableofficesf: "officespace",
};

export const TABLE_CONFIG_ID_TO_FIELD_LABEL_ALIASES: Record<string, string> = {
  addressline1: "Address",
  state: "State Province",
  availabledockdoors: "Docks",
  availablespace: "Available SF",
  maximumcontiguousavailablesf: "Max Contiguous SF",
  maximumcontiguousavailablesqm: "Max Contiguous Sq. m.",
  rentablebuildingsf: "Rentable SF",
  availabledriveindoors: "Drive-In Doors",
  carparkingspaces: "Parking Spaces Cars",
  constructiontype: "Construction",
  sprinklertype: "Sprinklers",
  datebuilt: "Year Built",
  leaserentalratesf: "Asking Rate",
  operatingexpensessf: "OPEX",
  tenantimprovement: "TI",
  inplacerent: "In-place Rent",
  legalownername: "Owner",
  availablerefrigeratorsf: "Available Refrigerated SF",
  propertyclasstype: "Building Class",
  availablecranes: "Cranes",
  hascrossdockconfiguration: "Cross Dock?",
  hasdriveindoors: "Drive-Ins?",
  grossbuildingsf: "Gross SF",
  hastrailerparking: "Has Trailer Parking?",
  availablepower: "Power",
  availableraildoors: "Rail Doors",
  hasrailaccess: "Rail?",
  trailerparking: "Parking Spaces Trailers",
  availablerefrigeratorsqm: "Available Refrigerated Sq. m.",
  minimumdivisibleavailablesqm: "Min Divisible Sq. m.",
  minimumdivisibleavailablesf: "Min Divisible SF",
  zoningcode: "Zoning",
  totalaskingrate: "Total Asking Rate (Base Rent + OPEX)",
  saleorleasebackvalue: "Sale/Leaseback Value",
  hasdockdoors: "Docks?",
  percentvacant: "% Vacant",
};

const PropertyFields = [
  { label: "Address", key: "address1" },
  { label: "Address Line 2", key: "address2" },
  { label: "Amenities", key: "amenities" },
  { label: "Total Sale Price", key: "askingPrice" },
  { label: "Asking Rate", key: "askingRent" },
  { label: "Building Class", key: "buildingClass" },
  { label: "Capacity", key: "capacity" },
  { label: "Center Type", key: "centerType" },
  { label: "City", key: "city" },
  { label: "Clear Height", key: "clearHeight" },
  { label: "Column Spacing", key: "columnSpacing" },
  { label: "Comments", key: "comments" },
  { label: "Cross Streets", key: "crossStreets" },
  { label: "Docks", key: "dockHighDoors" },
  { label: "Floors", key: "floors" },
  { label: "Latitude", key: "latitude" },
  { label: "Longitude", key: "longitude" },
  { label: "Lot Size", key: "lotSize" },
  { label: "Market", key: "market" },
  { label: "Property Name", key: "name" },
  { label: "Available Office SF", key: "officeSpace" },
  { label: "Owner", key: "owner" },
  { label: "Parking Ratio", key: "parkingRatio" },
  { label: "Parking Spaces", key: "parkingSpaces" },
  { label: "Parking Spaces Cars", key: "parkingSpacesCars" },
  { label: "Parking Spaces Trailers", key: "parkingSpacesTrailers" },
  { label: "Power", key: "powerAmps" },
  { label: "Property Size", key: "propertySize" },
  { label: "Sprinklers", key: "sprinklers" },
  { label: "State Province", key: "stateProvince" },
  { label: "Zip Code", key: "postalCode" },
  { label: "Submarket", key: "submarket" },
  { label: "Total Available Space", key: "totalAvailableSpace" },
  { label: "Virtual Tour", key: "virtualTour" },
  { label: "Year Built", key: "yearBuilt" },
  { label: "Year Renovated", key: "yearRenovated" },
  { label: "Zoning", key: "zoning" },
];

export default PropertyFields;

export const addressFields = [
  "name",
  "address1",
  "city",
  "stateProvince",
  "postalCode",
  "latitude",
  "longitude",
];

export const addressFieldsWithAddress2 = [
  "name",
  "address1",
  "address2",
  "city",
  "stateProvince",
  "postalCode",
  "latitude",
  "longitude",
];

export interface PropertyFormFieldConfig {
  fieldKey: string;
  label: string;
  size: "small" | "medium" | "large";
}

export const PROPERTY_FORM_FIELDS: PropertyFormFieldConfig[] = [
  {
    fieldKey: "propertySize",
    label: "Property Size",
    size: "small",
  },
  {
    fieldKey: "parkingSpaces",
    label: "# of Parking Spaces",
    size: "small",
  },
  {
    fieldKey: "totalAvailableSpace",
    label: "Total Available Space",
    size: "medium",
  },
  {
    fieldKey: "parkingRatio",
    label: "Parking Ratio",
    size: "small",
  },
  { fieldKey: "askingRent", label: "Asking Rate", size: "medium" },
  { fieldKey: "yearBuilt", label: "Year Built", size: "small" },
  {
    fieldKey: "askingPrice",
    label: "Total Sale Price",
    size: "medium",
  },
  {
    fieldKey: "yearRenovated",
    label: "Year Renovated",
    size: "small",
  },
  { fieldKey: "floors", label: "Floors in Building", size: "small" },
  { fieldKey: "owner", label: "Owner", size: "small" },
  {
    fieldKey: "buildingClass",
    label: "Building Class",
    size: "small",
  },
  { fieldKey: "virtualTour", label: "Virtual Tour", size: "medium" },
  { fieldKey: "amenities", label: "Amenities", size: "large" },
  { fieldKey: "comments", label: "Comments", size: "large" },
  {
    fieldKey: "clearHeight",
    label: "Clear Height",
    size: "medium",
  },
  {
    fieldKey: "parkingSpacesCars",
    label: "Parking Spaces - Cars",
    size: "small",
  },
  {
    fieldKey: "columnSpacing",
    label: "Column Spacing",
    size: "small",
  },
  {
    fieldKey: "parkingSpacesTrailers",
    label: "Parking Spaces - Trailers",
    size: "small",
  },
  { fieldKey: "dockHighDoors", label: "Docks", size: "small" },
  { fieldKey: "powerAmps", label: "Power", size: "small" },
  { fieldKey: "lotSize", label: "Lot Size", size: "small" },
  {
    fieldKey: "officeSpace",
    label: "Available Office SF",
    size: "medium",
  },
  { fieldKey: "sprinklers", label: "Sprinklers", size: "small" },
  {
    fieldKey: "crossStreets",
    label: "Cross Streets",
    size: "small",
  },
  { fieldKey: "capacity", label: "Capacity", size: "small" },
  { fieldKey: "centerType", label: "Center Type", size: "small" },
  { fieldKey: "market", label: "Market", size: "small" },
  { fieldKey: "submarket", label: "Submarket", size: "small" },
  { fieldKey: "zoning", label: "Zoning", size: "small" },
];

// UI display labels that differ from PropertyFields entries above.
// These are the exact strings rendered in PropertyInfoForm / PropertyDetailAddressForm.
export const PropertyDisplayLabels = [
  "Floors in Building",
  "# of Parking Spaces",
  "Street Address",
];

// Header mapping configuration for Excel import
export const ExcelHeaderMapping = {
  Name: "name",
  "Address Line 1": "address1",
  "Address Line 2": "address2",
  City: "city",
  State: "stateProvince",
  ZIP: "postalCode",
  Latitude: "latitude",
  Longitude: "longitude",
  "Building Size": "Building Size", // Custom field
  "Rentable SF": "Rentable SF", // Custom field
  "Clear Height": "clearHeight",
  Docks: "dockHighDoors",
  "Car Parking": "parkingSpacesCars",
  Construction: "Construction", // Custom field
  Sprinkler: "sprinklers",
  "Date Available": "Date Available", // Custom field
  "Year Built": "yearBuilt",
  "Asking Rate": "askingRent",
  Market: "market",
  "Property Notes": "Property Notes", // Custom field
};

// Additional business field mappings
export const BusinessFieldMappings = {
  "Property Name": "name",
  "Property Address": "address1",
  "Submarket Name": "submarket",
  RBA: "parkingSpacesTrailers",
  "Available Office SF": "officeSpace",
  Term: "centerType",
  "Clear Height": "clearHeight",
  NNN: "zoning",
};

// Function to resolve field mapping by checking PropertyFields first
export const resolveFieldMapping = (
  header: string,
  matchedAttribute: string,
) => {
  // First check if the matchedAttribute is already a PropertyField key (like "yearBuilt")
  const directKeyMatch = PropertyFields.find(
    (field) => field.key === matchedAttribute,
  );
  if (directKeyMatch) {
    return matchedAttribute;
  }

  // Then check if the matchedAttribute matches any PropertyField label (like "Year Built" → finds "yearBuilt")
  const attributeLabelMatch = PropertyFields.find(
    (field) => field.label.toLowerCase() === matchedAttribute.toLowerCase(),
  );
  if (attributeLabelMatch) {
    return attributeLabelMatch.key;
  }

  // Then check if the header itself matches any PropertyField label
  const headerLabelMatch = PropertyFields.find(
    (field) => field.label.toLowerCase() === header.toLowerCase(),
  );
  if (headerLabelMatch) {
    return headerLabelMatch.key;
  }

  // If no PropertyField match found, treat as custom field
  return matchedAttribute;
};

// Function to generate headerMapping array from the configuration
export const generateHeaderMapping = () => {
  return Object.entries(ExcelHeaderMapping).map(
    ([header, matchedAttribute]) => ({
      header,
      matchedAttribute: resolveFieldMapping(header, matchedAttribute),
    }),
  );
};

// Function to generate comprehensive header mapping including business fields
export const generateComprehensiveHeaderMapping = () => {
  // Get base mappings from existing configuration (already using resolveFieldMapping)
  const baseHeaderMapping = generateHeaderMapping();

  // Get additional business field mappings with the same priority logic
  const businessMappings = Object.entries(BusinessFieldMappings).map(
    ([header, matchedAttribute]) => ({
      header,
      matchedAttribute: resolveFieldMapping(header, matchedAttribute),
    }),
  );

  // Combine and remove duplicates
  const existingHeaders = new Set(
    baseHeaderMapping.map((mapping) => mapping.header),
  );
  const uniqueBusinessMappings = businessMappings.filter(
    (mapping) => !existingHeaders.has(mapping.header),
  );

  return [...baseHeaderMapping, ...uniqueBusinessMappings];
};
